<div class="header-container">
    <app-header></app-header>
</div>
<div>
    <router-outlet></router-outlet>
</div>
